<div id="app" class="h-100 app">
  <router-outlet></router-outlet>
</div>
